import React from "react";

export function Dividers(props: {
  children: React.ReactNode[];
  divider?: React.ReactNode | ((i: number) => React.ReactNode);
}) {
  const renderDivider = (i: number) => {
    if (i === 0) {
      return null;
    }
    if (!props.divider) {
      return <hr />;
    }
    if (props.divider instanceof Function) {
      return props.divider(i);
    }
    return props.divider;
  };
  return (
    <>
      {props.children
        .filter(e => typeof e !== "boolean" && !!e)
        .map((e, i) => (
          <React.Fragment key={i}>
            {renderDivider(i)}
            {e}
          </React.Fragment>
        ))}
    </>
  );
}
